var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _c("div", { ref: "panel", staticClass: "form-group card p-3" }, [
        _c(
          "div",
          [
            _c("label", { staticClass: "col-form-label" }, [_vm._v("Baslik")]),
            _vm._v(" "),
            _c("i18n-text", {
              key: Math.random(),
              attrs: {
                name: "visiting-point-title",
                value: _vm.visitingPoint.title,
                "create-hidden-input": false
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "py-2" }, [
          _c("label", { staticClass: "col-form-label" }, [_vm._v("Resim")]),
          _vm._v(" "),
          _c("div", { staticClass: "input-group" }, [
            _c(
              "div",
              {
                staticClass: "d-flex",
                staticStyle: { "align-items": "center", gap: "10px" }
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "btn btn-default",
                    attrs: { for: "files-" + _vm.visitingPoint.id }
                  },
                  [_vm._v("Resim ekle")]
                ),
                _vm._v(" "),
                _vm.visitingPoint.image && _vm.visitingPoint.image.thumbnail
                  ? _c("img", {
                      staticStyle: { width: "100px" },
                      attrs: {
                        id: "upload-file-info",
                        readonly: "",
                        src:
                          "" +
                          _vm.image_service +
                          _vm.visitingPoint.image.thumbnail
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  key: Math.random(),
                  staticClass: "btn btn-default",
                  staticStyle: { visibility: "hidden" },
                  attrs: {
                    id: "files-" + _vm.visitingPoint.id,
                    type: "file",
                    accept: "image/png, image/jpeg, image/jpg"
                  },
                  on: {
                    change: function($event) {
                      return _vm.preview($event, "image")
                    }
                  }
                }),
                _vm._v(" "),
                _vm.visitingPoint.image
                  ? _c(
                      "button",
                      {
                        key: Math.random(),
                        staticClass: "btn btn-danger btn-sm",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.deleteImage($event, "image")
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("close")
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "py-2" },
          [
            _c("label", { staticClass: "col-form-label" }, [
              _vm._v("Görevler")
            ]),
            _vm._v(" "),
            _c("i18n-textarea", {
              key: Math.random(),
              attrs: {
                name: "visiting-point-missions",
                value: _vm.visitingPoint.missions,
                "create-hidden-input": false
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "py-2" }, [
          _c("label", { staticClass: "col-form-label" }, [_vm._v("Geojson")]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.visitingPoint.geojson,
                expression: "visitingPoint.geojson"
              }
            ],
            key: Math.random(),
            staticClass: "form-control",
            attrs: { type: "text", rows: "5" },
            domProps: { value: _vm.visitingPoint.geojson },
            on: {
              input: [
                function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.visitingPoint, "geojson", $event.target.value)
                },
                function($event) {
                  return _vm.geoJsonUpdated()
                }
              ]
            }
          }),
          _vm._v(" "),
          _vm.isGeojsonValid
            ? _c("span", { staticStyle: { color: "red" } })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "py-2" },
          [
            _c("label", { staticClass: "col-form-label" }, [_vm._v("Oyunlar")]),
            _vm._v(" "),
            _vm.visitingPoint.showEditing
              ? _c("story-visiting-point-game-select", {
                  key: Math.random(),
                  attrs: { games: _vm.visitingPoint.games },
                  on: { "update-games": _vm.updateGames }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cecd092", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cecd092","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/vue/story-visiting-point-editor.vue
// module id = 106
// module chunks = 0